import Container from "@components/Container/Container";
import Edition from "@features/banner/Edition/Edition";
import { cn } from "@util/helpers";
import Cookies from "js-cookie";

import LogoMasthead from "./LogoMasthead/LogoMasthead";

export type MastheadProps = {
  /** Component to be rendered below the masthead */
  componentBelowMasthead?: React.ReactNode;
  /** Optional className for the masthead */
  className?: string;
  /** Logo Image size */
  imgWidth?: number;
  /** Optional indicator display edition switcher */
  isDisplayEditionSwitcher?: boolean;
};

const isGeoSg = Cookies.get("sph_user_country") === "SG";

export default function HomepageMasthead({
  componentBelowMasthead,
  className,
  imgWidth = 575,
  isDisplayEditionSwitcher,
}: MastheadProps): React.ReactElement {
  return (
    <Container rootClassName={cn("py-5 hidden lg:block", className)}>
      <>
        {isDisplayEditionSwitcher ? (
          <Edition isGeoSg={isGeoSg} className="mb-2 text-center uppercase" />
        ) : null}
      </>

      <div className="relative w-full flex-none">
        <LogoMasthead
          rootClassName={"flex justify-center"}
          imgWidth={imgWidth}
        />
      </div>

      <>{componentBelowMasthead}</>
    </Container>
  );
}
